import EventEmitter from 'eventemitter3';
import store from '@/store';
import i18n from '@/i18n';
import { ACTION } from '@/store/ACTION';
import { ICurrency } from '@/mainComponent/store/interfaces/newInterfaces/ICurrency';

class Preloader {
  static execution(): void {
    Preloader.createPromoAppMediator();
  }

  private static getAssetsLink() {
    let protocol = document.location.protocol;

    if (document.location.host.includes('localhost')) {
      protocol = 'https:';
    }

    const originWindowURLParams = new URLSearchParams(new URL(window.location.href).search);
    const assetsPath = originWindowURLParams.get('assets');

    if (!assetsPath) {
      throw new Error('ASSETS PATH IS NOT DEFINED!!!!!');
    }

    return `${protocol}//${assetsPath}`;
  }

  private static createPromoAppMediator(): void {
    // @ts-ignore
    window.promoApp = {
      eventEmitter: new EventEmitter(),
      store: store,
      i18n: i18n,
      currencyList: []
    };
    (async () => {
      const assets = this.getAssetsLink() + '/data/currency-list.json';
      const response = await fetch(assets);
      if (response.ok) {
        const { list: currency }: { list: ICurrency[] } = await response.json();
        // @ts-ignore
        window.promoApp.currencyList = currency;
        // promoApp.eventEmitter.emit(ACTION.SET_CURRENCY_LIST, currency);
      }
    })();

    // Установить данные с сервера по турнирам
    promoApp.eventEmitter.on(ACTION.SET_TOURNAMENT_DATA, data => {
      promoApp.store.dispatch(ACTION.SET_TOURNAMENT_DATA, data);
    });

    // Установить данные по пользователям с сервера
    promoApp.eventEmitter.on(ACTION.SET_TOURNAMENT_PLAYERS_DATA, data => {
      promoApp.store.dispatch(ACTION.SET_TOURNAMENT_PLAYERS_DATA, data);
    });

    // Установить конфигурацию для апп
    promoApp.eventEmitter.on(ACTION.SET_APP_CONFIGURATION, data => {
      promoApp.store.dispatch(ACTION.SET_APP_CONFIGURATION, data);
    });

    // Показать окно с приветствием для турниров
    promoApp.eventEmitter.on(ACTION.SHOW_WELCOME_POPUP, () => {
      promoApp.store.dispatch(ACTION.SHOW_WELCOME_POPUP);
    });

    // Спрятать окно с приветствием для турниров
    promoApp.eventEmitter.on(ACTION.HIDE_WELCOME_POPUP, () => {
      promoApp.store.dispatch(ACTION.HIDE_WELCOME_POPUP);
    });

    promoApp.eventEmitter.on(ACTION.SHOW_COMMON_POPUP, () => {
      promoApp.store.dispatch(ACTION.SHOW_COMMON_POPUP);
    });

    promoApp.eventEmitter.on(ACTION.HIDE_COMMON_POPUP, () => {
      promoApp.store.dispatch(ACTION.HIDE_COMMON_POPUP);
    });

    // Показать иконку для турниров
    promoApp.eventEmitter.on(ACTION.SHOW_PANEL_ICON, () => {
      promoApp.store.dispatch(ACTION.SHOW_PANEL_ICON);
    });

    // Спрятать иконку для турниров
    promoApp.eventEmitter.on(ACTION.HIDE_PANEL_ICON, () => {
      promoApp.store.dispatch(ACTION.HIDE_PANEL_ICON);
    });

    // Установить ланные с сервера по ачивкам
    promoApp.eventEmitter.on(ACTION.SET_ACHIEVEMENT_DATA, data => {
      promoApp.store.dispatch(ACTION.SET_ACHIEVEMENT_DATA, data);
    });

    //Показать инфу про выигрыш фри спинов
    promoApp.eventEmitter.on(ACTION.SHOW_FREESPIN_WIN, () => {
      promoApp.store.dispatch(ACTION.SHOW_FREESPIN_WIN);
    });

    //Скрыть инфу про выигрыш фри спинов
    promoApp.eventEmitter.on(ACTION.HIDE_FREESPIN_WIN, () => {
      promoApp.store.dispatch(ACTION.HIDE_FREESPIN_WIN);
    });

    //Показать инфу про окончание фри спинов
    promoApp.eventEmitter.on(ACTION.SHOW_FREESPIN_FINISH, data => {
      promoApp.store.dispatch(ACTION.SHOW_FREESPIN_FINISH, data);
    });

    //Скрыть инфу про окончание фри спинов
    promoApp.eventEmitter.on(ACTION.HIDE_FREESPIN_FINISH, () => {
      promoApp.store.dispatch(ACTION.HIDE_FREESPIN_FINISH);
    });

    //Показать инфу про выигрыш фри спинов в другой игре
    promoApp.eventEmitter.on(ACTION.SHOW_FREESPIN_WIN_OTHER_GAME, () => {
      promoApp.store.dispatch(ACTION.SHOW_FREESPIN_WIN_OTHER_GAME);
    });

    //Скрыть инфу про выигрыш фри спинов в другой игре
    promoApp.eventEmitter.on(ACTION.HIDE_FREESPIN_WIN_OTHER_GAME, () => {
      promoApp.store.dispatch(ACTION.HIDE_FREESPIN_WIN_OTHER_GAME);
    });

    // установка нужного промо, нужно в случае одновременной работы ачивок и турниров
    promoApp.eventEmitter.on(ACTION.SETTINGS_CORRECT_PROMO, () => {
      promoApp.store.dispatch(ACTION.SETTINGS_CORRECT_PROMO);
    });

    //смена иконок в промо
    promoApp.eventEmitter.on(ACTION.CHANGE_ICONS_PROMO, () => {
      promoApp.store.dispatch(ACTION.CHANGE_ICONS_PROMO);
    });

    // Показать прогрес бар
    promoApp.eventEmitter.on(ACTION.SHOW_PROGRESS_BAR, () => {
      promoApp.store.dispatch(ACTION.SHOW_PROGRESS_BAR);
    });

    // Скрыть прогрес бар
    promoApp.eventEmitter.on(ACTION.HIDE_PROGRESS_BAR, () => {
      promoApp.store.dispatch(ACTION.HIDE_PROGRESS_BAR);
    });

    // Показать подсказку не той ставки
    promoApp.eventEmitter.on(ACTION.SHOW_TOOLTIP, () => {
      promoApp.store.dispatch(ACTION.SHOW_TOOLTIP);
    });

    // Скрыть подсказку не той ставки
    promoApp.eventEmitter.on(ACTION.HIDE_TOOLTIP, () => {
      promoApp.store.dispatch(ACTION.HIDE_TOOLTIP);
    });

    // Показать меню
    promoApp.eventEmitter.on(ACTION.SHOW_MENU, () => {
      promoApp.store.dispatch(ACTION.SHOW_MENU);
    });

    // Скрыть меню
    promoApp.eventEmitter.on(ACTION.HIDE_MENU, () => {
      promoApp.store.dispatch(ACTION.HIDE_MENU);
    });

    // Очистить ачивки
    promoApp.eventEmitter.on(ACTION.CLEAR_ACHIEVEMENT, () => {
      promoApp.store.dispatch(ACTION.CLEAR_ACHIEVEMENT);
    });

    // Очистить турниры
    promoApp.eventEmitter.on(ACTION.CLEAR_TOURNAMENT, () => {
      promoApp.store.dispatch(ACTION.CLEAR_TOURNAMENT);
    });

    // Установить данные по фриспинам (в данном случае по трунирам)
    promoApp.eventEmitter.on(ACTION.SET_FREESPIN_DATA, data => {
      promoApp.store.dispatch(ACTION.SET_FREESPIN_DATA, data);
    });

    // Установаить данные по фрираундам
    promoApp.eventEmitter.on(ACTION.SET_FREE_ROUNDS_DATA, data => {
      promoApp.store.dispatch(ACTION.SET_FREE_ROUNDS_DATA, data);
    });

    // Настроить данные по PixelRatio
    promoApp.eventEmitter.on(ACTION.SET_PIXEL_RATIO, () => {
      promoApp.store.dispatch(ACTION.SET_PIXEL_RATIO);
    });

    // показать попап о выигрыше бонусной игры
    promoApp.eventEmitter.on(ACTION.SHOW_PRIZE_GAME_WIN, () => {
      promoApp.store.dispatch(ACTION.SHOW_PRIZE_GAME_WIN);
    });

    // скрыть попап о выигрыше бонусной игры
    promoApp.eventEmitter.on(ACTION.HIDE_PRIZE_GAME_WIN, () => {
      promoApp.store.dispatch(ACTION.HIDE_PRIZE_GAME_WIN);
    });

    // установить данные по фрибетам
    promoApp.eventEmitter.on(ACTION.SET_FREE_BETS_DATA, data => {
      promoApp.store.dispatch(ACTION.SET_FREE_BETS_DATA, data);
    });

    // установить данные по фрибет спинам
    promoApp.eventEmitter.on(ACTION.SET_FREE_BET_SPINS_DATA, data => {
      promoApp.store.dispatch(ACTION.SET_FREE_BET_SPINS_DATA, data);
    });

    // установить видимость иконки с каунтером
    promoApp.eventEmitter.on(ACTION.SET_PANEL_ICON_COUNT_VISIBLE, data => {
      promoApp.store.dispatch(ACTION.SET_PANEL_ICON_COUNT_VISIBLE, data);
    });

    // установить видимость прогресса с чеком
    promoApp.eventEmitter.on(ACTION.SET_PROGRESS_CHECK_VISIBLE, data => {
      promoApp.store.dispatch(ACTION.SET_PROGRESS_CHECK_VISIBLE, data);
    });

    // установить видимость велком попапа с табами
    promoApp.eventEmitter.on(ACTION.SET_TAB_WELCOME_VISIBLE, data => {
      promoApp.store.dispatch(ACTION.SET_TAB_WELCOME_VISIBLE, data);
    });

    // показать сообщение
    promoApp.eventEmitter.on(ACTION.SET_MESSAGE_VISIBLE, data => {
      promoApp.store.dispatch(ACTION.SET_MESSAGE_VISIBLE, data);
    });
  }
}

export { Preloader };
